import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const todayStart = dayjs().startOf('day').toISOString();
const todayEnd = dayjs().endOf('day').toISOString();

const initialState = {
  searchText: '',
  filterReference: '',
  filterStatus: null,
  orderDateRange: [null, null],
  deliveryDateRange: [todayStart, todayEnd],
  dateFilterType: 'order', // 'order' | 'delivery'
  showTodayOnly: false,
  selectedShopId: null,
  isAllShops: true,
};

const shopOrdersFiltersSlice = createSlice({
  name: 'shopOrdersFilters',
  initialState,
  reducers: {
    setShopOrdersSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setShopOrdersFilterReference: (state, action) => {
      state.filterReference = action.payload;
    },
    setShopOrdersFilterStatus: (state, action) => {
      state.filterStatus = action.payload;
    },
    setShopOrdersOrderDateRange: (state, action) => {
      state.orderDateRange = action.payload;
    },
    setShopOrdersDeliveryDateRange: (state, action) => {
      state.deliveryDateRange = action.payload;
    },
    setShopOrdersDateFilterType: (state, action) => {
      state.dateFilterType = action.payload;
    },
    setShopOrdersShowTodayOnly: (state, action) => {
      state.showTodayOnly = action.payload;
    },
    setShopOrdersSelectedShopId: (state, action) => {
      state.selectedShopId = action.payload;
    },
    setShopOrdersIsAllShops: (state, action) => {
      state.isAllShops = action.payload;
    },
    resetShopOrdersFilters: () => initialState,
  },
});

export const {
  setShopOrdersSearchText,
  setShopOrdersFilterReference,
  setShopOrdersFilterStatus,
  setShopOrdersOrderDateRange,
  setShopOrdersDeliveryDateRange,
  setShopOrdersDateFilterType,
  setShopOrdersShowTodayOnly,
  resetShopOrdersFilters,
  setShopOrdersSelectedShopId,
  setShopOrdersIsAllShops,
} = shopOrdersFiltersSlice.actions;

export default shopOrdersFiltersSlice.reducer;